export default {
  props: {
    // 组件名称
    componentName: {
      default: '',
      type: String,
    },
    // 组件类型
    componentType: {
      default: 0,
      type: Number,
    },
    // 组件标题
    componentTitle: {
      default: '',
      type: String,
    },
    // 栏目标题
    title: {
      default: '',
      type: String,
    },
    // 栏目描述
    describe: {
      default: '',
      type: String,
    },
    // 内容项列表
    dataList: {
      default: () => [],
      type: Array,
    },
    // 轮播图自动播放时间 单位秒
    delayTime: {
      default: '1',
      type: String,
    },
    // dotColor是否生效 1-是 2-否
    emphasis: {
      default: '2',
      type: String,
    },
    // 标题前 点颜色
    dotColor: {
      default: '#000000',
      type: String,
    },
  },
}
